import { createItemsStoreWrapper } from '~/utils/pinia/items-store-setup'
import { useSettingsStore } from '~/stores/common/settings'
import type { ItemsStoreQuery } from '~/utils/pinia/types'
import type { FantasyCalendarDay } from '~/types/fantasy'

const createItemsStore = createItemsStoreWrapper<'id', FantasyCalendarDay>()

export const useFantasyCalendarStore = createItemsStore(
  'fantasy-calendar',
  {
    path: (_query: ItemsStoreQuery, options: Record<string, unknown>) =>
      `/api/v1/fantasy/season/${options.seasonId}/days`,
    idKey: 'id',
    query: {
      expand: ['memberStatus', 'rewards.resource'],
      sort: 'date'
    }
  },
  context => {
    const closestOpenDayId = computed(() => {
      const day = context.items.value.find(day => day.can_set_slot)
      return day ? day.id : null
    })

    const defaultDayId = computed(
      () => closestOpenDayId.value ?? context.items.value.at(-1)?.id ?? null
    )

    const seasonDaysLeft = computed(() => {
      const lastDay = context.items.value.at(-1)
      const settingsStore = useSettingsStore()

      if (!lastDay || !settingsStore.data?.time) return null

      const diff = lastDay.date_timestamp - settingsStore.data.time
      if (diff <= 0) return 0

      return Math.ceil(diff / 86400)
    })

    return { closestOpenDayId, defaultDayId, seasonDaysLeft }
  }
)
